import { Loader } from '@opoint/infomedia-storybook'

const LoadingPage = () => (
  <div className="flex h-screen w-full items-center justify-center">
    <Loader />
  </div>
)

export default LoadingPage
